export const SkillsData = [
  {
    type: "Frontend",
    list: [
      {
        name: "Reactjs",
        icon: <i class="devicon-react-original colored"></i>,
      },

      {
        name: "JavaScript",
        icon: <i class="devicon-javascript-plain colored"></i>,
      },

      {
        name: "Material UI",
        icon: <i class="devicon-materialui-plain colored"></i>,
      },

      {
        name: "CSS",
        icon: <i class="devicon-css3-plain colored"></i>,
      },
    ],
  },
  {
    type: "Backend",
    list: [
      {
        name: "Nodejs",
        icon: <i class="devicon-nodejs-plain colored"></i>,
      },
      {
        name: "Solidity",
        icon: <i class="devicon-solidity-plain colored"></i>,
      },
      {
        name: "Firebase",
        icon: <i class="devicon-firebase-plain colored"></i>,
      },
    ],
  },
  {
    type: "Operating System",
    list: [
      {
        name: "Windows",
        icon: <i class="devicon-windows8-original colored"></i>,
      },
      {
        name: "Ubuntu",
        icon: <i class="devicon-ubuntu-plain colored"></i>,
      },
    ],
  },

  {
    type: "Development Tools",
    list: [
      {
        name: "VSCode",
        icon: <i class="devicon-vscode-plain colored"></i>,
      },
      {
        name: "Atom",
        icon: <i class="devicon-atom-original colored"></i>,
      },
    ],
  },
];
